<template>
  <div class="store">
    <div
      class="parallax contaier-overlay"
      id="parralax"
      style="overflow: hidden;height: 300px;"
    >
      <div class="scroll-overlay"></div>
      <h1
        class="text-white text-center"
        style="z-index: 7;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);"
      >
        Boutique
      </h1>
    </div>

    <!-- Shop -->
    <div class="shop">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <!-- Shop Sidebar -->
            <div class="shop_sidebar z-depth-1 p-3 mb-3">
              <div class="sidebar_section">
                <div class="sidebar_title">Categories</div>
                <ul class="sidebar_categories list-unstyled">
                  <li><a href="#">MOBILIER CLINIQUE</a></li>
                  <li><a href="#">ELECTROMÉDECINE</a></li>
                  <li><a href="#">UNIFORMES ET SÉCURITÉ</a></li>
                  <li><a href="#">STÉRILISATION</a></li>
                  <li><a href="#">DIAGNOSTIC</a></li>
                  <li><a href="#">KINÉSITHÉRAPIE ET MASSAGE</a></li>
                </ul>
              </div>
              <div class="sidebar_section filter_by_section">
                <div class="sidebar_title">Filtrer par</div>
                <div class="sidebar_subtitle">Prix</div>
                <div class="filter_price">
                  <div id="slider-range" class="slider_range"></div>
                  <p>Gamme:</p>
                  <p>
                    <input
                      type="text"
                      id="amount"
                      class="amount"
                      readonly
                      style="border:0; font-weight:bold;"
                    />
                  </p>
                </div>
              </div>
              <div class="sidebar_section">
                <div class="sidebar_subtitle color_subtitle">Couleur</div>
                <ul class="colors_list">
                  <li class="color">
                    <a href="#" style="background: #b19c83;"></a>
                  </li>
                  <li class="color">
                    <a href="#" style="background: #000000;"></a>
                  </li>
                  <li class="color">
                    <a href="#" style="background: #999999;"></a>
                  </li>
                  <li class="color">
                    <a href="#" style="background: #0e8ce4;"></a>
                  </li>
                  <li class="color">
                    <a href="#" style="background: #df3b3b;"></a>
                  </li>
                  <li class="color">
                    <a
                      href="#"
                      style="background: #ffffff; border: solid 1px #e1e1e1;"
                    ></a>
                  </li>
                </ul>
              </div>
              <div class="sidebar_section">
                <div class="sidebar_subtitle brands_subtitle list-unstyled">
                  Brands
                </div>
                <ul class="brands_list">
                  <li class="brand"><a href="#">marque 1</a></li>
                  <li class="brand"><a href="#">marque 2</a></li>
                  <li class="brand"><a href="#">marque 3</a></li>
                  <li class="brand"><a href="#">marque 4</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-9">
            <!-- Shop Content -->

            <div class="shop_content ">
              <div class="shop_bar clearfix">
                <div class="shop_product_count">
                  <span id="nbrItems"></span> Produits trouvés
                </div>
                <div class="shop_sorting">
                  <span>Trier par:</span>
                  <ul>
                    <li>
                      <span class="sorting_text"
                        >Les mieux notés <i class="fas fa-chevron-down"></i
                      ></span>
                      <ul>
                        <li
                          class="shop_sorting_button"
                          data-isotope-option='{ "sortBy": "best" }'
                        >
                          Les meix notés
                        </li>
                        <li
                          class="shop_sorting_button"
                          data-isotope-option='{ "sortBy": "name" }'
                        >
                          nom
                        </li>
                        <li
                          class="shop_sorting_button"
                          data-isotope-option='{ "sortBy": "price" }'
                        >
                          prix
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="product_grid">
                <div class="product_grid_border"></div>
              </div>

              <nav aria-label="Page navigation example ">
                <ul class="pagination pg-blue justify-content-center py-4">
                  <li class="page-item disabled">
                    <a class="page-link">Previous</a>
                  </li>
                  <li class="page-item disabled"><a class="page-link">1</a></li>
                  <li class="page-item disabled ">
                    <a class="page-link">2</a>
                  </li>
                  <li class="page-item disabled"><a class="page-link">3</a></li>
                  <li class="page-item disabled">
                    <a class="page-link">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {};
</script>   

<style lang="scss" scoped>
/* start parallex scroll */

.contaier-overlay {
  position: relative;
}
.contaier-overlay .scroll-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 6;
  bottom: 0;
  right: 0;
}

.parallax {
  height: 510px;
  width: 100vw;
  /* padding-top: 20vh; */
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
}
#parralax {
  background-image: url("../assets/image/mm.jpg");
}
</style>